import {
  VirtualizedMapGrid as Component,
  useRichGridRenderer
} from 'ui-components'
import useInfiniteSearchMapsQuery from '~map-search/hooks/useInfiniteSearchMapsQuery'

const VirtualizedMapGrid = (props) => {
  const { ready, itemsPerRow } = useRichGridRenderer()

  const { data, getItems, isFetching, hasMoreItems } =
    useInfiniteSearchMapsQuery({
      initialNumToRender: itemsPerRow * 3,
      skip: !ready
    })

  const handleEndReached = (event, itemsPerRow) => {
    if (hasMoreItems) {
      getItems({ from: data?.searchMaps?.size, size: itemsPerRow * 2 })
    }
  }

  return (
    <Component
      {...props}
      loading={isFetching}
      items={data.searchMaps?.items || []}
      hasMoreItems={hasMoreItems}
      onEndReached={handleEndReached}
    />
  )
}

export { VirtualizedMapGrid }
